module.exports = __webpack_public_path__ + "img/ionebank_visual_m.55ddd0d0.jpg";